import i18n from "../i18n";

class labels {
  // Skip links
  static skipToHeader = "Spring til header";
  static skipToNavigation = "Spring til navigation";
  static skipToMainContent = "Spring til indhold";

  // Page Header
  static get needHelp() {
    return i18n.t("needHelp");
  }

  static get lockVisits() {
    return i18n.t("lockVisits");
  }

  static get endLockVisits() {
    return i18n.t("endLockVisits");
  }

  static get lockVisitsTooltip() {
    return i18n.t("lockVisitsTooltip");
  }
  static get lockTaskError() {
    return i18n.t("lockTaskError");
  }
  static get lockVisitsInfo() {
    return i18n.t("lockVisitsInfo");
  }
  static get finalizeLockVisits() {
    return i18n.t("finalizeLockVisits");
  }

  // Drawer
  static get closeDrawer() {
    return i18n.t("closeDrawer");
  }

  // Empty state
  static get missingPlanToday() {
    return i18n.t("missingPlanToday");
  }
  static get goToNexusToSendData() {
    return i18n.t("goToNexusToSendData");
  }

  // Error messages
  static get nexusConnectionError() {
    return i18n.t("nexusConnectionError");
  }
  static get fetchPlanError() {
    return i18n.t("fetchPlanError");
  }
  static get fetchPreferencesError() {
    return i18n.t("fetchPreferencesError");
  }

  // KPI cards
  static get rulesCompliance() {
    return i18n.t("rulesCompliance");
  }
  static get preferencesCompliance() {
    return i18n.t("preferencesCompliance");
  }
  static get preferredTimeCompliance() {
    return i18n.t("preferredTimeCompliance");
  }
  static get unplannedVisits() {
    return i18n.t("unplannedVisits");
  }
  static get transportationKm() {
    return i18n.t("transportationKm");
  }
  static get distanceMeassurement() {
    return i18n.t("distanceMeassurement");
  }

  // Warnings
  static get noTransportCalculated() {
    return i18n.t("noTransportCalculated");
  }

  // Gantt chart
  static get lockAllRoutes() {
    return i18n.t("lockAllRoutes");
  }

  static get address() {
    return i18n.t("address");
  }
  static get citizens() {
    return i18n.t("citizens");
  }
  static get citizen() {
    return i18n.t("citizen");
  }
  static get visit() {
    return i18n.t("visit");
  }
  static get citizenVisits() {
    return i18n.t("citizenVisits");
  }
  static get employeeAppointments() {
    return i18n.t("employeeAppointments");
  }
  static get visitHours() {
    return i18n.t("visitHours");
  }
  static get visitDetails() {
    return i18n.t("visitDetails");
  }
  static get employees() {
    return i18n.t("employees");
  }
  static get employee() {
    return i18n.t("employee");
  }
  static get minutes() {
    return i18n.t("minutes");
  }
  static get hours() {
    return i18n.t("hours");
  }
  static get details() {
    return i18n.t("details");
  }
  static get dependencies() {
    return i18n.t("dependencies");
  }
  static get task() {
    return i18n.t("task");
  }
  static get tasks() {
    return i18n.t("tasks");
  }
  static get priority() {
    return i18n.t("priority");
  }
  static get citizenDetails() {
    return i18n.t("citizenDetails");
  }
  static get skillRequirement() {
    return i18n.t("skillRequirement");
  }
  static get skills() {
    return i18n.t("skills");
  }
  static get time() {
    return i18n.t("time");
  }
  static get expenses() {
    return i18n.t("expenses");
  }
  static get keyNumbers() {
    return i18n.t("keyNumbers");
  }
  static get citizenService() {
    return i18n.t("citizenService");
  }
  static get plannedTime() {
    return i18n.t("plannedTime");
  }
  static get plannedEmployees() {
    return i18n.t("plannedEmployees");
  }
  static get unplannedEmployees() {
    return i18n.t("unplannedEmployees");
  }
  static get timeWithCitizens() {
    return i18n.t("timeWithCitizens");
  }
  static get appointments() {
    return i18n.t("appointments");
  }
  static get appointmentsWithServices() {
    return i18n.t("appointmentsWithServices");
  }
  static get outlookAppointments() {
    return i18n.t("outlookAppointments");
  }
  static get transportation() {
    return i18n.t("transportation");
  }
  static get transportationTime() {
    return i18n.t("transportationTime");
  }
  static get plan() {
    return i18n.t("plan");
  }
  static get manualWorkTime() {
    return i18n.t("manualWorkTime");
  }
  static get continuityTooltip() {
    return i18n.t("continuityTooltip");
  }
  static get rulesComplianceTooltip() {
    return i18n.t("rulesComplianceTooltip");
  }
  static get preferencesComplianceTooltip() {
    return i18n.t("preferencesComplianceTooltip");
  }
  static get preferredTimeComplianceTooltip() {
    return i18n.t("preferredTimeComplianceTooltip");
  }
  static get plannedEmployeesTooltip() {
    return i18n.t("plannedEmployeesTooltip");
  }
  static get unplannedVisitsTooltip() {
    return i18n.t("unplannedVisitsTooltip");
  }
  static get drivenDistanceTooltip() {
    return i18n.t("drivenDistanceTooltip");
  }
  static get drivingTimeTooltip() {
    return i18n.t("drivingTimeTooltip");
  }
  static get visitTimeShareTooltip() {
    return i18n.t("visitTimeShareTooltip");
  }
  static get drivingTimeShareTooltip() {
    return i18n.t("drivingTimeShareTooltip");
  }
  static get employeeAppointmentTimeShareTooltip() {
    return i18n.t("employeeAppointmentTimeShareTooltip");
  }
  static get appointmentTimeShareTooltip() {
    return i18n.t("appointmentTimeShareTooltip");
  }
  static get appointmentWithServicesTimeShareTooltip() {
    return i18n.t("appointmentWithServicesTimeShareTooltip");
  }
  static get outlookAppointmentTimeShareTooltip() {
    return i18n.t("outlookAppointmentTimeShareTooltip");
  }
  static get shiftTimeTooltip() {
    return i18n.t("shiftTimeTooltip");
  }
  static get manualWorkTimeTooltip() {
    return i18n.t("manualWorkTimeTooltip");
  }
  static get unplannedWorkTimeTooltip() {
    return i18n.t("unplannedWorkTimeTooltip");
  }
  static get plannedWorkTimeTooltip() {
    return i18n.t("plannedWorkTimeTooltip");
  }
  static get unplannedTime() {
    return i18n.t("unplannedTime");
  }
  static get affinity() {
    return i18n.t("affinity");
  }
  static get filter() {
    return i18n.t("filter");
  }
  static get AIMissing() {
    return i18n.t("AIMissing");
  }
  static get AICompleted() {
    return i18n.t("AICompleted");
  }
  static get search() {
    return i18n.t("search");
  }
  static get choosePeriod() {
    return i18n.t("choosePeriod");
  }
  static get chooseOption() {
    return i18n.t("chooseOption");
  }
  static get locked() {
    return i18n.t("locked");
  }
  static get nexusRules() {
    return i18n.t("nexusRules");
  }
  static get blocked() {
    return i18n.t("blocked");
  }
  static get score() {
    return i18n.t("score");
  }
  static get rules() {
    return i18n.t("rules");
  }
  static get competencies() {
    return i18n.t("competencies");
  }
  static get assignedEmployee() {
    return i18n.t("assignedEmployee");
  }
  static get preferences() {
    return i18n.t("preferences");
  }
  static get preferred() {
    return i18n.t("preferred");
  }
  static get kpiPreferences() {
    return i18n.t("kpiPreferences");
  }
  static get kpiPreferred() {
    return i18n.t("kpiPreferred");
  }
  static get preferredTime() {
    return i18n.t("preferredTime");
  }
  static get continuity() {
    return i18n.t("continuity");
  }
  static get high() {
    return i18n.t("high");
  }
  static get normal() {
    return i18n.t("normal");
  }
  static get low() {
    return i18n.t("low");
  }
  static get searchPrompt() {
    return i18n.t("searchPrompt");
  }
  static get compareWithNexus() {
    return i18n.t("compareWithNexus");
  }
  static get error() {
    return i18n.t("error");
  }
  static get results() {
    return i18n.t("results");
  }

  // Date Picker
  static get moveDayForward() {
    return i18n.t("moveDayForward");
  }
  static get moveDayBackward() {
    return i18n.t("moveDayBackward");
  }
  static get datePicker() {
    return i18n.t("datePicker");
  }

  //Zoom
  static get zoomIn() {
    return i18n.t("zoomIn");
  }
  static get zoomOut() {
    return i18n.t("zoomOut");
  }

  // Task Dependencies
  static get isDependencyOfTitle() {
    return i18n.t("isDependencyOfTitle");
  }
  static get dependsOnTitle() {
    return i18n.t("dependsOnTitle");
  }
  static get startTimeColumnLabel() {
    return i18n.t("startTimeColumnLabel");
  }
  static get endTimeColumnLabel() {
    return i18n.t("endTimeColumnLabel");
  }

  // Violations
  static get violation() {
    return i18n.t("violation");
  }
  static get unplannedTask() {
    return i18n.t("unplannedTask");
  }
  static get violationSkill() {
    return i18n.t("violationSkill");
  }
  static get violationDependency() {
    return i18n.t("violationDependency");
  }
  static get violationDependencyUnplanned() {
    return i18n.t("violationDependencyUnplanned");
  }
  static get violationDependencySameEmployee() {
    return i18n.t("violationDependencySameEmployee");
  }
  static get violationDependencyTime() {
    return i18n.t("violationDependencyTime");
  }
  static get violationOverdue() {
    return i18n.t("violationOverdue");
  }
  static get violationOvertime() {
    return i18n.t("violationOvertime");
  }
  static get violationTravelTotalDistance() {
    return i18n.t("violationTravelTotalDistance");
  }
  static get violationTravelTripDistance() {
    return i18n.t("violationTravelTripDistance");
  }
  static get violationTravelFirstLastTripDistance() {
    return i18n.t("violationTravelFirstLastTripDistance");
  }
  static get violationOfTotalTravelDistance() {
    return i18n.t("violationOfTotalTravelDistance");
  }
  static get violationOfTravelTripDistance() {
    return i18n.t("violationOfTravelTripDistance");
  }
  static get violationOfFirstLastTripDistance() {
    return i18n.t("violationOfFirstLastTripDistance");
  }
  static get violationBlockedEmployee() {
    return i18n.t("violationBlockedEmployee");
  }
  static get violationNoEmployeeWithNecessarySkill() {
    return i18n.t("violationNoEmployeeWithNecessarySkill");
  }
  static get violationTaskInvalidTimeWindow() {
    return i18n.t("violationTaskInvalidTimeWindow");
  }
  static get violationTaskInvalidLinkedTaskDuration() {
    return i18n.t("violationTaskInvalidLinkedTaskDuration");
  }
  static get violationValidationCircularReference() {
    return i18n.t("violationValidationCircularReference");
  }
  static get violationTaskTooLateStartComparedToEmployees() {
    return i18n.t("violationTaskTooLateStartComparedToEmployees");
  }
  static get violationTaskTooEarlyStartComparedToEmployees() {
    return i18n.t("violationTaskTooEarlyStartComparedToEmployees");
  }
  static get violationTaskTooEarlyStartComparedToLockedEmployee() {
    return i18n.t("violationTaskTooEarlyStartComparedToLockedEmployee");
  }
  static get violationTaskTooLateStartComparedToLockedEmployee() {
    return i18n.t("violationTaskTooLateStartComparedToLockedEmployee");
  }
  static get violationNoEmployees() {
    return i18n.t("violationNoEmployees");
  }
  static get violationTaskExpandedTimeWindowNotEnclosePreferredTimeWindow() {
    return i18n.t(
      "violationTaskExpandedTimeWindowNotEnclosePreferredTimeWindow",
    );
  }
  static get violationTasksInvalidMinOrMaxDuration() {
    return i18n.t("violationTasksInvalidMinOrMaxDuration");
  }
  static get violationEmployeesNotWorking() {
    return i18n.t("violationEmployeesNotWorking");
  }
  static get violationTaskOutsideWorkTime() {
    return i18n.t("violationTaskOutsideWorkTime");
  }
  static get violationConcernCategoryEmployee() {
    return i18n.t("violationConcernCategoryEmployee");
  }
  static violationRestrictedEmployee = (names: string) =>
    i18n.t("violationRestrictedEmployee", { names });
  static get restrictedEmployeeFallbackName() {
    return i18n.t("restrictedEmployeeFallbackName");
  }
  static get citizenAppointmentModifiedTitle() {
    return i18n.t("citizenAppointmentModifiedTitle");
  }
  static get citizenAppointmentModifiedText() {
    return i18n.t("citizenAppointmentModifiedText");
  }
  static get originalPreferredTime() {
    return i18n.t("originalPreferredTime");
  }
  static get originalAllowedTime() {
    return i18n.t("originalAllowedTime");
  }

  // Violation messages
  static get unspecifiedViolationMessage() {
    return i18n.t("unspecifiedViolationMessage");
  }
  static dependencyMinOverlapViolationMessage = (minutes: string) =>
    i18n.t("dependencyMinOverlapViolationMessage", { minutes });
  static get sameEmployeeViolationMessage() {
    return i18n.t("sameEmployeeViolationMessage");
  }
  static maxDelayTimeViolationMessage = (
    minutes: string,
    anchor: "START" | "END",
  ) => i18n.t("maxDelayTimeViolationMessage", { minutes, context: anchor });
  static minDelayTimeViolationMessage = (
    minutes: string,
    anchor: "START" | "END",
  ) => i18n.t("minDelayTimeViolationMessage", { minutes, context: anchor });
  static get sameStartViolationMessage() {
    return i18n.t("sameStartViolationMessage");
  }
  static get startRightAfterViolationMessage() {
    return i18n.t("startRightAfterViolationMessage");
  }

  // buttons
  static get sinceNexusData() {
    return i18n.t("sinceNexusData");
  }
  static get sendNexusData() {
    return i18n.t("sendNexusData");
  }
  static get sendingToNexus() {
    return i18n.t("sendingToNexus");
  }
  static get UpdatePlan() {
    return i18n.t("UpdatePlan");
  }
  static get undo() {
    return i18n.t("undo");
  }

  // login page
  static get login() {
    return i18n.t("login");
  }

  static get hoverEmployee() {
    return i18n.t("hoverEmployee");
  }
  static get hoverTasks() {
    return i18n.t("hoverTasks");
  }

  static pondooCompleted = (duration: string) =>
    i18n.t("pondooCompleted", { duration });
  static get pondooNotUpdated() {
    return i18n.t("pondooNotUpdated");
  }
  static get pondooMissing() {
    return i18n.t("pondooMissing");
  }
  static get pondooStatusError() {
    return i18n.t("pondooStatusError");
  }
  static get pondooStatusAborted() {
    return i18n.t("pondooStatusAborted");
  }
  static get pondooStatusCalculating() {
    return i18n.t("pondooStatusCalculating");
  }
  static get pondooNexusLandingError() {
    return i18n.t("pondooNexusLandingError");
  }
  static get pondooRunning() {
    return i18n.t("pondooRunning");
  }
  static get pondooFetchingData() {
    return i18n.t("pondooFetchingData");
  }
  static get tryAgain() {
    return i18n.t("tryAgain");
  }
  static get ruleset() {
    return i18n.t("ruleset");
  }
  static get selectRuleset() {
    return i18n.t("selectRuleset");
  }
  static get update() {
    return i18n.t("update");
  }
  static get abortOptimization() {
    return i18n.t("abortOptimization");
  }
  static get runOptimization() {
    return i18n.t("runOptimization");
  }
  static get wantToRunOptimizationWithRuleset() {
    return i18n.t("wantToRunOptimizationWithRuleset");
  }

  static get nexusLandingDataAlreadyExistsWarningHeader() {
    return i18n.t("nexusLandingDataAlreadyExistsWarningHeader");
  }
  static get nexusLandingDataAlreadyExistsWarningBody() {
    return i18n.t("nexusLandingDataAlreadyExistsWarningBody");
  }
  static get nexusLandingPageGoToExistingButton() {
    return i18n.t("nexusLandingPageGoToExistingButton");
  }
  static get nexusLandingPageOverwriteData() {
    return i18n.t("nexusLandingPageOverwriteData");
  }
  static get nexusLandingPageStartingImport() {
    return i18n.t("nexusLandingPageStartingImport");
  }
  static get nexusLandingRunInProgressHeader() {
    return i18n.t("nexusLandingRunInProgressHeader");
  }
  static nexusLandingRunInProgressStartedAt = (
    time: string,
    name: string | null,
  ) =>
    name
      ? i18n.t("nexusLandingRunInProgressStartedAtBy", { time, name })
      : i18n.t("nexusLandingRunInProgressStartedAt", { time });
  static get nexusLandingRunInProgressBody() {
    return i18n.t("nexusLandingRunInProgressBody");
  }
  static get nexusLandingRunInProgressStopAndRestart() {
    return i18n.t("nexusLandingRunInProgressStopAndRestart");
  }
  static get nexusLandingRunInProgressFollow() {
    return i18n.t("nexusLandingRunInProgressFollow");
  }
  static get nexusLandingStepFetching() {
    return i18n.t("nexusLandingStepFetching");
  }
  static get nexusLandingStepNexusReady() {
    return i18n.t("nexusLandingStepNexusReady");
  }
  static get nexusLandingStepCalculating() {
    return i18n.t("nexusLandingStepCalculating");
  }
  static get nexusLandingStepDone() {
    return i18n.t("nexusLandingStepDone");
  }
  static get importValidationWarningHeader() {
    return i18n.t("importValidationWarningHeader");
  }
  static get importValidationWarningShiftTrimmedIntro() {
    return i18n.t("importValidationWarningShiftTrimmedIntro");
  }
  static get importValidationWarningNexusWorkTime() {
    return i18n.t("importValidationWarningNexusWorkTime");
  }
  static get importValidationWarningAdjustedTo() {
    return i18n.t("importValidationWarningAdjustedTo");
  }
  static get importValidationWarningPondooWorkTime() {
    return i18n.t("importValidationWarningPondooWorkTime");
  }
  static get importValidationWarningOk() {
    return i18n.t("importValidationWarningOk");
  }
  static get runSupersededToastTitle() {
    return i18n.t("runSupersededToastTitle");
  }
  static runSupersededToastBody = (time: string, name: string | null) =>
    name
      ? i18n.t("runSupersededToastBodyBy", { time, name })
      : i18n.t("runSupersededToastBody", { time });
  static get ganttChartLockErrorMessage() {
    return i18n.t("ganttChartLockErrorMessage");
  }
  static get ganttChartLockShiftWarningHeader() {
    return i18n.t("ganttChartLockShiftWarningHeader");
  }
  static get ganttChartLockShiftWarningBody() {
    return i18n.t("ganttChartLockShiftWarningBody");
  }
  static get ganttChartLockShiftCancel() {
    return i18n.t("ganttChartLockShiftCancel");
  }
  static get ganttChartLockShiftProceed() {
    return i18n.t("ganttChartLockShiftProceed");
  }
  static openEmployeeDrawer(employeeName: string): string {
    return i18n.t("openEmployeeDrawer", { employeeName });
  }
  static toggleEmployeeLock(employeeName: string): string {
    return i18n.t("toggleEmployeeLock", { employeeName });
  }
  static removeSearchFilter(name: string): string {
    return i18n.t("removeSearchFilter", { name });
  }
  static get clearSearch() {
    return i18n.t("clearSearch");
  }

  // Time units
  static dayAmount = (amount: number): string =>
    i18n.t("dayAmount", { count: amount });
  static hoursAmount = (amount: number): string =>
    i18n.t("hoursAmount", { count: amount });
  static minutesAmount = (amount: number): string =>
    i18n.t("minutesAmount", { count: amount });
  static secondsAmount = (amount: number): string =>
    i18n.t("secondsAmount", { count: amount });

  // Parameterized toast messages
  static stopOptimizationToastMessage = (date: string) =>
    i18n.t("stopOptimizationToastMessage", { date });

  // Nexus Export Error Modal
  static get nexusExportErrorHeader() {
    return i18n.t("nexusExportErrorHeader");
  }
  static get nexusExportErrorBody() {
    return i18n.t("nexusExportErrorBody");
  }
  static get nexusExportErrorUnappliedTaskRefs() {
    return i18n.t("nexusExportErrorUnappliedTaskRefs");
  }
  static get nexusExportErrorClose() {
    return i18n.t("nexusExportErrorClose");
  }
  static get nexusExportErrorRetry() {
    return i18n.t("nexusExportErrorRetry");
  }
  static get nexusExportUnknownTask() {
    return i18n.t("nexusExportUnknownTask");
  }
  static get nexusExportUnknownEmployee() {
    return i18n.t("nexusExportUnknownEmployee");
  }
  static get nexusExportErrorGeneral() {
    return i18n.t("nexusExportErrorGeneral");
  }
  static get nexusExportPartialFailure() {
    return i18n.t("nexusExportPartialFailure");
  }
  static get nexusExportSuccess() {
    return i18n.t("nexusExportSuccess");
  }
  static get nexusServerConnectionError() {
    return i18n.t("nexusServerConnectionError");
  }

  // constraint tabs
  static get categoryConstraints() {
    return i18n.t("categoryConstraints");
  }
  static get individualConstraints() {
    return i18n.t("individualConstraints");
  }
  static get addCategoryConstraints() {
    return i18n.t("addCategoryConstraints");
  }
  static get addIndividualConstraints() {
    return i18n.t("addIndividualConstraints");
  }
  static get addConstraint() {
    return i18n.t("addConstraint");
  }
  static get showActiveConstraintsOnly() {
    return i18n.t("showActiveConstraintsOnly");
  }
  static get showCitizensWithConstraintsOnly() {
    return i18n.t("showCitizensWithConstraintsOnly");
  }
  static get consideration() {
    return i18n.t("consideration");
  }
  static get comment() {
    return i18n.t("comment");
  }
  static get startDate() {
    return i18n.t("startDate");
  }
  static get endDate() {
    return i18n.t("endDate");
  }
  static get start() {
    return i18n.t("start");
  }
  static get end() {
    return i18n.t("end");
  }
  static get selectStartDate() {
    return i18n.t("selectStartDate");
  }
  static get selectEndDate() {
    return i18n.t("selectEndDate");
  }
  static get addCommentPlaceholder() {
    return i18n.t("addCommentPlaceholder");
  }
  static get searchCategoryConstraint() {
    return i18n.t("searchCategoryConstraint");
  }
  static get searchCitizenConstraint() {
    return i18n.t("searchCitizenConstraint");
  }
  static get typeName() {
    return i18n.t("typeName");
  }
  static get searchEmployeeConstraint() {
    return i18n.t("searchEmployeeConstraint");
  }
  static get createNew() {
    return i18n.t("createNew");
  }
  static get author() {
    return i18n.t("author");
  }
  static get editCategory() {
    return i18n.t("editCategory");
  }
  static get editConstraint() {
    return i18n.t("editConstraint");
  }
  static get categoryNamePlaceholder() {
    return i18n.t("categoryNamePlaceholder");
  }
  static get errorFetchEmployees() {
    return i18n.t("errorFetchEmployees");
  }
  static get errorFetchCategories() {
    return i18n.t("errorFetchCategories");
  }
  static get errorFetchClients() {
    return i18n.t("errorFetchClients");
  }
  static get errorSaveConstraint() {
    return i18n.t("errorSaveConstraint");
  }
  static get errorConstraintAlreadyExists() {
    return i18n.t("errorConstraintAlreadyExists");
  }
  static errorConstraintAlreadyExistsWithName = (
    clashingName: string,
  ): string => i18n.t("errorConstraintAlreadyExistsWithName", { clashingName });
  static get errorSaveCategory() {
    return i18n.t("errorSaveCategory");
  }
  static get errorCategoryNameTaken() {
    return i18n.t("errorCategoryNameTaken");
  }
  static errorCategoryNameTakenWithName = (clashingName: string): string =>
    i18n.t("errorCategoryNameTakenWithName", { clashingName });
  static get errorUpdateCategory() {
    return i18n.t("errorUpdateCategory");
  }
  static get errorUpdateConstraint() {
    return i18n.t("errorUpdateConstraint");
  }
  static get errorDeleteCategory() {
    return i18n.t("errorDeleteCategory");
  }
  static get errorDeleteConstraint() {
    return i18n.t("errorDeleteConstraint");
  }
  static get constraintExplainerTitle() {
    return i18n.t("constraintExplainerTitle");
  }
  static get constraintExplainerIntro() {
    return i18n.t("constraintExplainerIntro");
  }
  static get constraintExplainerCategoryTitle() {
    return i18n.t("constraintExplainerCategoryTitle");
  }
  static get constraintExplainerCategoryBody() {
    return i18n.t("constraintExplainerCategoryBody");
  }
  static get constraintExplainerRelationTitle() {
    return i18n.t("constraintExplainerRelationTitle");
  }
  static get constraintExplainerRelationBody() {
    return i18n.t("constraintExplainerRelationBody");
  }

  // calendar settings
  static get generalSettings() {
    return i18n.t("generalSettings");
  }
  static get skillProfiles() {
    return i18n.t("skillProfiles");
  }
  static get addressSettingsInfo() {
    return i18n.t("addressSettingsInfo");
  }
  static get addressSettings() {
    return i18n.t("addressSettings");
  }
  static get startAddress() {
    return i18n.t("startAddress");
  }
  static get endAddress() {
    return i18n.t("endAddress");
  }
  static get workTimeSettingsInfo() {
    return i18n.t("workTimeSettingsInfo");
  }
  static get workTimeSettings() {
    return i18n.t("workTimeSettings");
  }
  static get startTime() {
    return i18n.t("startTime");
  }
  static get endTime() {
    return i18n.t("endTime");
  }
  static get teamSettings() {
    return i18n.t("teamSettings");
  }

  static get teamSettingsReadOnly(): string {
    return i18n.t("teamSettingsReadOnly");
  }
  static get nexusTeamHex() {
    return i18n.t("nexusTeamHex");
  }
  static get pondooTeamName() {
    return i18n.t("pondooTeamName");
  }
  static get groupEmployeesInTeams() {
    return i18n.t("groupEmployeesInTeams");
  }
  static get seeAll() {
    return i18n.t("seeAll");
  }
  static get noAddress() {
    return i18n.t("noAddress");
  }
  static get noTeams() {
    return i18n.t("noTeams");
  }
  static get noTeamsExplained() {
    return i18n.t("noTeamsExplained");
  }

  // employee drawer
  static get employeeSettings() {
    return i18n.t("employeeSettings");
  }
  static movedFromTeamToday = (team: string) =>
    i18n.t("movedFromTeamToday", { team });

  static get teamMoveTitle() {
    return i18n.t("teamMoveTitle");
  }

  static get dailySettings() {
    return i18n.t("dailySettings");
  }
  static get permanentSettings() {
    return i18n.t("permanentSettings");
  }
  static get editWorkingHours() {
    return i18n.t("editWorkingHours");
  }
  static get transport() {
    return i18n.t("transport");
  }
  static get deleteWorkTime() {
    return i18n.t("deleteWorkTime");
  }
  static get selectWorkTime() {
    return i18n.t("selectWorkTime");
  }
  static get workTimeStartEqualsEndError() {
    return i18n.t("workTimeStartEqualsEndError");
  }
  static get workTimeEndBeforeStartError() {
    return i18n.t("workTimeEndBeforeStartError");
  }
  static get deleteWorkTimeWarningBody() {
    return i18n.t("deleteWorkTimeWarningBody");
  }
  static get edit() {
    return i18n.t("edit");
  }
  static get delete() {
    return i18n.t("delete");
  }
  static get deleteConstraint() {
    return i18n.t("deleteConstraint");
  }
  static get deleteConstraintWarningBody() {
    return i18n.t("deleteConstraintWarningBody");
  }
  static deleteCategoryTitleWithName = (categoryName: string): string =>
    i18n.t("deleteCategoryTitleWithName", { categoryName });
  static get deleteCategoryInUseIntro() {
    return i18n.t("deleteCategoryInUseIntro");
  }
  static deleteCategoryImpactBody = (
    employeeCount: number,
    citizenCount: number,
  ): string =>
    i18n.t("deleteCategoryImpactBody", { employeeCount, citizenCount });
  static get deleteCategoryWarningBody() {
    return i18n.t("deleteCategoryWarningBody");
  }
  static get continue() {
    return i18n.t("continue");
  }
  static get addTransportType() {
    return i18n.t("addTransportType");
  }
  static get transportType() {
    return i18n.t("transportType");
  }
  static get chooseTransport() {
    return i18n.t("chooseTransport");
  }
  static get startTimeTransport() {
    return i18n.t("startTimeTransport");
  }
  static get endTimeTransport() {
    return i18n.t("endTimeTransport");
  }
  static get transportCar() {
    return i18n.t("transportCar");
  }
  static get transportBike() {
    return i18n.t("transportBike");
  }
  static get transportElectricBike() {
    return i18n.t("transportElectricBike");
  }
  static get transportWalking() {
    return i18n.t("transportWalking");
  }
  static get errorEmptyFields() {
    return i18n.t("errorEmptyFields");
  }
  static get errorOutsideWorkHours() {
    return i18n.t("errorOutsideWorkHours");
  }
  static get errorOverlappingTimeWindow() {
    return i18n.t("errorOverlappingTimeWindow");
  }
  static get errorNotFilledWorkHours() {
    return i18n.t("errorNotFilledWorkHours");
  }
  static get errorTransportCoversFullWorkTime() {
    return i18n.t("errorTransportCoversFullWorkTime");
  }
  static get errorWorkTimeConflictsWithTransport() {
    return i18n.t("errorWorkTimeConflictsWithTransport");
  }
  static get save() {
    return i18n.t("save");
  }
  static get discard() {
    return i18n.t("discard");
  }
  static get manuallyEditedWorkTime() {
    return i18n.t("manuallyEditedWorkTime");
  }
  static get manuallyEditedTransport() {
    return i18n.t("manuallyEditedTransport");
  }
  static get unsavedChanges() {
    return i18n.t("unsavedChanges");
  }
  static get saveChangesWarningBody() {
    return i18n.t("saveChangesWarningBody");
  }
  static get discardAndCloseModal() {
    return i18n.t("discardAndCloseModal");
  }
  static get saveAndCloseModal() {
    return i18n.t("saveAndCloseModal");
  }
  static get citizenPreferences() {
    return i18n.t("citizenPreferences");
  }
  static get continuityScore() {
    return i18n.t("continuityScore");
  }
  static get visitsToday() {
    return i18n.t("visitsToday");
  }
  static get addCitizen() {
    return i18n.t("addCitizen");
  }
  static get cancel() {
    return i18n.t("cancel");
  }
  static get addPreference() {
    return i18n.t("addPreference");
  }
  static get searchForCitizen() {
    return i18n.t("searchForCitizen");
  }
  static get outOf() {
    return i18n.t("outOf");
  }
  static get rememberToCreateOperationalTask() {
    return i18n.t("rememberToCreateOperationalTask");
  }

  //Drag and drop
  static get endingDragAndDropSessionWaningText() {
    return i18n.t("endingDragAndDropSessionWaningText");
  }
  static get endingDragAndDropSessionWaningHeader() {
    return i18n.t("endingDragAndDropSessionWaningHeader");
  }
  static get deleteDragAndDropCustomPlan() {
    return i18n.t("deleteDragAndDropCustomPlan");
  }
  static get returnToDragAndDropEdit() {
    return i18n.t("returnToDragAndDropEdit");
  }
  static get moveTaskFailedError() {
    return i18n.t("moveTaskFailedError");
  }
  static get dragAndDropSessionExpiredError() {
    return i18n.t("dragAndDropSessionExpiredError");
  }
  static get toastSuccessTitle() {
    return i18n.t("toastSuccessTitle");
  }
  static get toastErrorTitle() {
    return i18n.t("toastErrorTitle");
  }
  static get toastInfoTitle() {
    return i18n.t("toastInfoTitle");
  }
  static get planSavedSuccess() {
    return i18n.t("planSavedSuccess");
  }
  static get planSaveFailedError() {
    return i18n.t("planSaveFailedError");
  }
  static get fetchPlanningDatesError() {
    return i18n.t("fetchPlanningDatesError");
  }
  static get updatePreferencesError() {
    return i18n.t("updatePreferencesError");
  }

  //Drag and drop statusbar
  static get calculatingTransportation() {
    return i18n.t("calculatingTransportation");
  }
  static get expandTransportTime() {
    return i18n.t("expandTransportTime");
  }
  static get expandTransportTimeDescription() {
    return i18n.t("expandTransportTimeDescription");
  }
  static get replanFromTimeTitle() {
    return i18n.t("replanFromTimeTitle");
  }
  static get replanFromTimeDescription() {
    return i18n.t("replanFromTimeDescription");
  }
  static get replanFromTimePlaceholder() {
    return i18n.t("replanFromTimePlaceholder");
  }
  static get capacityAdjustmentTitle() {
    return i18n.t("capacityAdjustmentTitle");
  }
  static get capacityAdjustmentDescription() {
    return i18n.t("capacityAdjustmentDescription");
  }
  static get violations() {
    return i18n.t("violations");
  }
  static get saveChanges() {
    return i18n.t("saveChanges");
  }

  //Contingency settings
  static get contingencyPlanIsActive() {
    return i18n.t("contingencyPlanIsActive");
  }
  static get selectServiceLevel() {
    return i18n.t("selectServiceLevel");
  }
  static get contingencyTitle() {
    return i18n.t("contingencyTitle");
  }
  static get contingencyDescription() {
    return i18n.t("contingencyDescription");
  }
  static get contingencyDescriptionBeta() {
    return i18n.t("contingencyDescriptionBeta");
  }
  static get contingencySettingsDescriptionBeta() {
    return i18n.t("contingencySettingsDescriptionBeta");
  }
  static get includeVisitTypes() {
    return i18n.t("includeVisitTypes");
  }
  static get searchVisitTypePlaceholder() {
    return i18n.t("searchVisitTypePlaceholder");
  }
  static get adjustmentScope() {
    return i18n.t("adjustmentScope");
  }
  static get noAdjustment() {
    return i18n.t("noAdjustment");
  }
  static get adjustmentInfoBeta() {
    return i18n.t("adjustmentInfoBeta");
  }
  static get smallAdjustment() {
    return i18n.t("smallAdjustment");
  }
  static get mediumAdjustment() {
    return i18n.t("mediumAdjustment");
  }
  static get largeAdjustment() {
    return i18n.t("largeAdjustment");
  }
  static reducesVisitDuration = (percent: number): string =>
    i18n.t("reducesVisitDuration", { percent });
  static get doesNotReduceVisitDuration() {
    return i18n.t("doesNotReduceVisitDuration");
  }
  static expandsTimeWindow = (minutes: number): string =>
    i18n.t("expandsTimeWindow", { minutes });
  static get doesNotExpandTimeWindow() {
    return i18n.t("doesNotExpandTimeWindow");
  }
  static get contingencyPresetsFetchError() {
    return i18n.t("contingencyPresetsFetchError");
  }
  static get expandedTransportOnly() {
    return i18n.t("expandedTransportOnly");
  }
  static get contingencySettingsSection() {
    return i18n.t("contingencySettingsSection");
  }
  static get selectMinimumTime() {
    return i18n.t("selectMinimumTime");
  }
  static get adjustVisitsOverMinimum() {
    return i18n.t("adjustVisitsOverMinimum");
  }
  static get selectTime() {
    return i18n.t("selectTime");
  }
  static get contingencyStartsFrom() {
    return i18n.t("contingencyStartsFrom");
  }
  static get runContingency() {
    return i18n.t("runContingency");
  }
  static get contingencyModeIndicator() {
    return i18n.t("contingencyModeIndicator");
  }
  static get contingencyCalculating() {
    return i18n.t("contingencyCalculating");
  }
  static kpiContinuityTooltip(value: number): string {
    return i18n.t("kpiContinuityTooltip", { value });
  }
  static kpiTransportTooltip(value: number): string {
    return i18n.t("kpiTransportTooltip", { value });
  }
  static kpiViolationsTooltip(value: number): string {
    return i18n.t("kpiViolationsTooltip", { value });
  }
  static employeeCategoryTooltip(count: number, hours: number): string {
    return i18n.t("employeeCategoryTooltip", { count, hours });
  }
  static citizenVisitCategoryTooltip(count: number, hours: number): string {
    return i18n.t("citizenVisitCategoryTooltip", { count, hours });
  }
  static employeeAppointmentCategoryTooltip(
    count: number,
    hours: number,
  ): string {
    return i18n.t("employeeAppointmentCategoryTooltip", { count, hours });
  }
}

export default labels;
